import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentIconBlocks } from '../../components/SectionContentIconBlocks'

export const SectionContentInstanceMissionValues: React.FunctionComponent =
  () => (
    <Section backgroundColor="white" padding={100}>
      <SectionContentIconBlocks
        heading="Our core values influence every facet of our operations"
        iconBlocks={[
          {
            id: 'humility',
            heading: 'Humility',
            description:
              "We don't have all the answers. We improve as an org through individually closing the feedback loop by listening with intent and without ego.",
            icon: {
              publicId: 'icons/values-humility',
              alt: 'Humility is a core value at Qwick',
            },
          },
          {
            id: 'data-driven',
            heading: 'Data-Driven',
            description:
              'We shape our strategies around customer feedback and data, placing customer needs at the forefront of our business choices.',
            icon: {
              publicId: 'icons/icon-data-driven',
              alt: 'Making decisions large and small based on data',
            },
          },
          {
            id: 'innovation',
            heading: 'Innovation',
            description:
              'We strive to constantly innovate while consistently delivering value to our pros and businesses.',
            icon: {
              publicId: 'icons/values-innovation',
              alt: 'Innovation is a core value at Qwick',
            },
          },
        ]}
      />
    </Section>
  )
